import { createTheme, ThemeProvider } from "@mui/material/styles"
import { WebAppProvider } from "@vkruglikov/react-telegram-web-app"

import TelegramApp from "../components/TelegramApp"

import "./style.scss"

const theme = createTheme({
  palette: { primary: { main: "#23664b" }, text: { primary: "#1c3028", secondary: "#6c7b70" } },
  typography: { fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif" },
  shape: { borderRadius: 12 },
})

const App = () => (
  <ThemeProvider theme={theme}>
    <div className="App">
      <WebAppProvider
        options={{
          smoothButtonsTransition: true,
        }}
      >
        <TelegramApp />
      </WebAppProvider>
    </div>
  </ThemeProvider>
)

export default App
